<template>
  <div class="v-input-auth-code">
    <div
      v-for="(value, index) in inputs"
      :key="index"
      class="v-input-auth-code__input"
    >
      <input
        v-model="inputs[index]"
        type="tel"
        maxlength="1"
        :autofocus="index === 0"
        @keydown="onKeyDown"
        @input="onInput"
        @focus="onFocus"
        ref="inputs"
      />
      <div class="v-input-auth-code__input__outline"></div>
    </div>
    <input type="hidden" :name="name" :value="authcode"/>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      inputs: new Array(this.length).fill(""),
      currentInput: null
    };
  },
  computed: {
    completed() {
      return !this.inputs.some(el => !el);
    },
    authcode() {
      if (this.completed) this.$refs.inputs[5].focus();
      return this.completed ? this.inputs.join("") : "";
    }
  },
  watch: {
    completed(isCompleted) {
      this.$emit(isCompleted ? "complete" : "incomplete");
    }
  },
  mounted() {
    this.$refs.inputs[0].focus();
    this.$refs.inputs[0].onpaste = e => {
      const chars = e.clipboardData.getData("text");
      const pastedChars = chars.split("");
      if (chars.length == 6 && !isNaN(+chars)) {
        pastedChars.forEach((value, index) => {
          this.inputs[index] = value;
        });
      } else {
        e.preventDefault();
      }
    };
  },
  methods: {
    onFocus(event) {
      this.currentInput = this.$refs.inputs.indexOf(event.target);
      event.target.select();
    },
    onKeyDown(event) {
      if (!this.validKeys(event)) {
        event.preventDefault();
      }
      if (this.currentInput > 0 && event.keyCode === 8) {
        this.focusPreviousInput();
      }
    },
    onInput(event) {
      if (!this.isNumber(event.data)) return;
      if (this.currentInput < this.length - 1) {
        this.focusNextInput();
      }
    },
    focusPreviousInput() {
      if (
        this.currentInput == this.length - 1 &&
        this.inputs[this.currentInput]
      ) {
        this.$refs.inputs[this.currentInput].focus();
      } else {
        this.$refs.inputs[this.currentInput - 1].focus();
      }
    },
    focusNextInput() {
      this.$refs.inputs[this.currentInput + 1].focus();
    },
    validKeys(event) {
      // 8 = backspace, 9 = tab, 17 = CTRL, 85 = v
      return this.isNumber(event.key) || [8, 9, 17, 86].includes(event.keyCode);
    },
    isNumber(value) {
      return /^[\d]/.test(value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-input-auth-code {
  display: flex;

  &__input {
    position: relative;
    width: 45px;
    height: 50px;

    & + & {
      margin-left: $spacer * 0.5;
    }

    input {
      border: none !important;
      outline: 0;
      background: transparent;
      width: 100%;
      height: 100%;
      text-align: center;
      color: theme-color("dark");
      font-family: "Lota Grotesque", Arial, Helvetica, sans-serif;
      font-size: 24px;
      font-weight: bold;

      &::selection {
        background-color: transparent;
      }
    }

    &__outline {
      position: absolute;
      display: flex;
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      max-width: 100%;
      height: 100%;
      border: 1px solid theme-color("border");
      border-radius: 5px;
      pointer-events: none;
      transition: all 100ms ease-out;
    }

    input:focus ~ &__outline {
      border-color: theme-color("focus");
      border-width: 2px;
    }
  }
}
</style>
